import React, { Component } from "react";
import { connect } from "react-redux";
//
import Screen from "./ConnectedScreen";

class PhoneHelpScreen extends Component {
  render() {
    const { goBack } = this.props;

    return (
      <Screen
        title="Why SMS verification"
        isActive
        nextLabel="Continue"
        onNext={(ev) => goBack()}
      >
        <p>
          We use <strong>SMS verification</strong> as a way of showing that a
          booking is genuine and to update you through your booking experience.
        </p>
        <p>
          Once you have verified your number via an SMS{" "}
          <strong>One Time Password</strong> (OTP), the booking is sent out to
          the companion or agency for them to confirm.
          <br />
          Once the booking is confirm the companion/agency are then able to
          contact you during the booking.
        </p>
        <p>
          We will only use your number during your booking. We will never share
          your contact details with any other third parties, and you will only
          receieve the following <strong>3 discreet messages</strong> from us:
        </p>
        <ul className="u-mb" style={{ marginLeft: "36px" }}>
          <li>
            A message to inform you that your booking has been
            accepted/declined/cancelled.
          </li>
          <li>
            A message to inform you when your guest is on the way (with GPS
            tracking link).
          </li>
          <li>
            A message to allow you to rate/review your experience after
            completion.
          </li>
        </ul>

        <p>
          If you are having any difficulties getting your OTP please email us at{" "}
          <a href="mailto:contact@smooci.com">contact@smooci.com</a> for
          assistance.
        </p>
      </Screen>
    );
  }
}

// @connect
import { goToBack } from "../modules/modal";
function mapDispatch(dispatch) {
  return {
    goBack() {
      dispatch(goToBack());
    },
  };
}

export default connect(
  null,
  mapDispatch
)(PhoneHelpScreen);
